<template>
  <label class="checkbox" :for="forInput">
    <slot></slot> <span>{{ text }}</span>
  </label>
</template>

<script>
export default {
  props: {
    forInput: {
      required: true,
      type: String
    },
    text: {
      required: true,
      type: String
    }
  }
}
</script>

<style lang="scss">
.checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
  color:  #595d60;
  font-family: $ToyotaBook;
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;

  span {
    position: relative;
    padding-left: 36px;

    &::before {
      @include pseudo(16px, 16px, 'checkbox-icon.svg');
      @include vertical-center;

      left: 0;
    }
  }

  input {
    display: none;

    &:checked ~ span {
      &::before {
        @include pseudo(16px, 16px, 'checkbox-icon-checked.svg');
      }
    }
  }
}

@include media-min($desktop-width) {
  .checkbox {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// components/_UI/BaseCheckbox.vue